export enum Protocol {
  V2 = 'V2',
  V3 = 'V3',
  BAL_STABLE = 'BAL',
  BAL_STABLE_WRAPPER = 'ERC4626',
  MIXED = 'MIXED',
}
